export * from 'isomorphic-fetch';
export * from 'core-js/es/map';
export * from 'core-js/es/set';
export * from 'core-js/es/object';
export * from 'core-js/es/function';
export * from 'core-js/es/array';
export * from 'core-js/es/string';
export * from 'core-js/es/number';
export * from 'core-js/es/date';
export * from 'core-js/es/promise';
export * from 'core-js/es/symbol';
export * from 'regenerator-runtime/runtime';

// CustomEvent polyfill to fix Apple Sign In on IE 11
// https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent#Polyfill
(function () {
    if (typeof window.CustomEvent === 'function') {
        return;
    }
    function CustomEvent(event, params) {
        params = params || { bubbles: false, cancelable: false, detail: null };
        const evt = document.createEvent('CustomEvent');
        evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
        return evt;
    }

    window.CustomEvent = CustomEvent;
})();
